import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ background: "#F7F7F7" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Comprehensive <span>Logistics App Development</span> Services
            </h2>
            <p>
              Accelerate your logistics operations with our cutting-edge,
              custom-built apps designed to enhance speed, security, and
              operational control. Overcome modern challenges with our
              full-fledged logistics app development services and access faster
              technology, intelligent automation, and seamless integration to
              boost productivity and profitability.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Logistics App
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Custom Logistics Software Development</h4>
                  <p>
                    Our tailored logistics software addresses your specific
                    business needs, optimizing workflows, enhancing
                    communication, and automating manual processes for increased
                    operational efficiency and cost savings.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>IoT Integration</h4>
                  <p>
                    Enable real-time tracking and monitoring with IoT-connected
                    devices across your supply chain. Improve asset tracking,
                    fleet management, and predictive maintenance to reduce
                    downtime and enhance overall visibility.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Data Analytics & Reporting</h4>
                  <p>
                    Harness the power of data with advanced analytics and
                    reporting tools. Track performance, identify inefficiencies,
                    and make data-driven decisions that improve route planning,
                    inventory management, and customer service.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Mobile App Development for Logistics</h4>
                  <p>
                    Empower your mobile workforce with custom-built logistics
                    applications. Enable real-time communication, task
                    management, and GPS tracking to ensure efficient on-the-go
                    operations and quick issue resolution.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>System Integration Services</h4>
                  <p>
                    Seamlessly integrate new or custom-built logistics solutions
                    with your existing systems like ERP, CRM, and WMS. Our
                    integration expertise ensures smooth data flow, optimized
                    processes, and minimal disruption.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>AI-Powered Logistics Solutions</h4>
                  <p>
                    Automate critical processes with AI-driven logistics
                    applications. Leverage real-time data analysis for smarter
                    decision-making, cost reduction, and improved customer
                    satisfaction through predictive insights and automation.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
